import { getSrc } from "@components/HomePage/logos/utils";
import dropbox from "./images/dropbox.png";
import gdrive from "./images/gdrive.png";
import instagram from "./images/instagram.svg";
import meganz from "./images/meganz.png";
import rutube from "./images/rutube.png";

const previews = {
	dropbox: getSrc(dropbox),
	gdrive: getSrc(gdrive),
	instagram: getSrc(instagram),
	meganz: getSrc(meganz),
	rutube: getSrc(rutube),
};

export default previews;
